import { inject, Injectable } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { RecaptchaFormGroup } from '../interfaces/forms/recaptcha-form.interface';

@Injectable({
  providedIn: 'root',
})
export class RecaptchaFormService {
  public readonly fb = inject(FormBuilder);

  public formGroup: RecaptchaFormGroup;

  public initFormGroup(): RecaptchaFormGroup {
    this.formGroup = this.fb.group({
      recaptcha: new FormControl('', [Validators.required]),
    });

    return this.formGroup;
  }
}
